import React from 'react'
import StaticComponent from './StaticComponent'
import { connect } from 'react-redux'
import * as actions from '../actions'
import Howler from 'react-howler'

const mapStateToProps = (state) => ({
  isPlaying: state.currentTrack.isPlaying,
  elapsed: state.currentTrack.elapsed,
  volume: state.currentTrack.volume,
  didSeek: state.currentTrack.didSeek,
  resource: state.currentTrack.meta.resource || '/', // Required for some reason, otherwise it doesn't work when changing tracks
  cached: state.currentTrack.meta.cached,
  track: state.currentTrack.meta,
  source: state.audioPlayer.source,
  html5: state.audioPlayer.html5
})

const mapDispatchToProps = (dispatch) => ({
  tickCurrentTrack: (tick) => dispatch(actions.tickCurrentTrack(tick)),
  unseekCurrentTrack: () => dispatch(actions.unseekCurrentTrack()),
  playNextTrack: () => dispatch(actions.playNextTrack()),
  setSource: (source) => dispatch(actions.setSource(source)),
  setHTML5: (enabled) => dispatch(actions.setHTML5(enabled))
})

class AudioPlayer extends React.Component {

  componentDidMount () {
    // Start the ticker only if the track is currently playing

  }

  componentWillUnmount () {
    // Always clear the ticker if for whatever reason the AudioPlayer is unmounted
    clearInterval(this.ticker)
  }

  async componentWillUpdate (nextProps) {
    // // If track went from paused to playing and resource didn't change, user may have "seeked"
    // if (nextProps.isPlaying !== this.props.isPlaying &&
    //     nextProps.resource === this.props.resource) {
    //   console.log('seek')
    //   this.howler.seek(this.props.elapsed)
    // }
    // If the track will start playing and resource is valid, start the ticker
    // Also, set the elapsed time on the track. This may have changed
    // Only perform update when play state changes
    if (nextProps.didSeek && !this.props.didSeek) {
      this.props.unseekCurrentTrack()
      this.howler.seek(nextProps.elapsed)
    }

    else if (nextProps.isPlaying && !this.props.isPlaying) {
      this.ticker = setInterval(() => this.tick(nextProps), 90)
    }

    // If the track will be paused, pause the ticker
    else if (!nextProps.isPlaying && this.props.isPlaying) {
      clearInterval(this.ticker)
    }

    // Detect track change
    if (nextProps.track.id !== this.props.track.id) {
      // Handle the resource fetching
      const src = await this.fetchSource(nextProps.track)

      console.log(src)

      this.props.setHTML5(!this.props.track.cached)
      this.props.setSource(src)
    }

  }

  fetchSource = async (track) => {
    if (track.resource === '/') return '/'
    // If the track isn't cached, we'll let Howler do the loading with its XHRs
    if (!track.cached) {
      return `${process.env.REACT_APP_API_ENDPOINT}`+track.resource
    }

    const promise = new Promise( (resolve, reject) => {

      // The reader takes a blob and converts it to a base64 data URI
      const reader = new FileReader()
      reader.addEventListener('load', () => {
        resolve(reader.result)
      })

      const base64Audio = fetch(`${process.env.REACT_APP_API_ENDPOINT}`+track.resource, {
        headers: {
          'x-should-cache': true
        }
      })
      .then(response => response.blob())
      .then(blob => {
        reader.readAsDataURL(blob)
      })
    })

    return promise
  }

  tick = (nextProps) => {
    if (nextProps.resource !== '/') {
      let progress = this.howler.seek()
      // Sometimes seek() returns a howler object for some reason
      // We need to double check that it's a number
      if (isNaN(parseFloat(progress))) return

      this.props.tickCurrentTrack(progress)
    }

  }

  onTrackEnd = () => {
    clearInterval(this.ticker)
    this.props.playNextTrack()
  }

  render () {
    return (
      <Howler ref={(howler) => this.howler = howler}
          preload={false}
          src={this.props.source}
          playing={this.props.isPlaying}
          onEnd={this.onTrackEnd}
          volume={this.props.volume}
          html5={this.props.html5} // Start playing ASAP, while still downloading rest of file. If the file is cached, we want to disable the "HTML5" streaming and read from cache in a whole chunk instead.
        />
    )
  }
}

AudioPlayer = connect(mapStateToProps, mapDispatchToProps)(AudioPlayer)

export default StaticComponent(AudioPlayer)



// WEBPACK FOOTER //
// ./src/components/AudioPlayer.js